<div class="secure-doc-viewer-dialog" (contextmenu)="disableRightClick($event)">
  <div class="dialog-header">
    <div class="dialog-title-block">
      <span class="dialog-title" [title]="title">{{ title }}</span>
      <span class="document-file-name" *ngIf="documentFileName" [title]="documentFileName">
        {{ documentFileName }}
      </span>
      <span class="image-description" *ngIf="mediaType === 'image' && imageDescription" [title]="imageDescription">
        {{ imageDescription }}
      </span>
      <span class="viewer-reference-document" *ngIf="hasReferenceDocument">
        Reference document:
        <a href="javascript:void(0)" class="viewer-reference-file" [title]="referenceFileName"
          (click)="openReferenceDocument(referencePageNumber, $event)">{{ referenceFileName }}</a>
        <span class="viewer-reference-page" *ngIf="referencePageNumber"> (Page number:{{ referencePageNumber }})</span>
      </span>
    </div>
      <span class="showpadMessage" *ngIf=" !isShowpad && showpad_doc_url && !roleName">
      <p>Your account does not currently have access to ShowPad. If you need access, please fill out <a [href]="URL" target="_blank" rel="noopener noreferrer">this form</a> and select <b>ShowPad > User Addition within the form.</b></p>
    </span>

    <div class="header-actions">
      <button mat-icon-button *ngIf="mediaType === 'image' && enableImageZoomActions" (click)="zoomOutImage()" title="Zoom out"
        [disabled]="imageZoomScale <= minImageZoomScale">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <span class="image-zoom-label" *ngIf="mediaType === 'image' && enableImageZoomActions">{{ (imageZoomScale * 100) | number:'1.0-0' }}%</span>
      <button mat-icon-button *ngIf="mediaType === 'image' && enableImageZoomActions" (click)="zoomInImage()" title="Zoom in"
        [disabled]="imageZoomScale >= maxImageZoomScale">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button mat-icon-button *ngIf="mediaType === 'image' && enableImageZoomActions" (click)="resetImageZoom()" title="Reset zoom">
        <mat-icon>restart_alt</mat-icon>
      </button>
      <button mat-icon-button *ngIf="mediaType === 'image' && enableImageCopyActions" (click)="copyImageToClipboard()" title="Copy image">
        <mat-icon>content_copy</mat-icon>
      </button>
      <button mat-icon-button (click)="toggleMaximize()" [title]="isMaximized ? 'Restore' : 'Maximize'">
        <mat-icon>{{ isMaximized ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
      </button>
      <button mat-icon-button (click)="closeDialog()" title="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-body" [class.image-zoom-enabled]="mediaType === 'image' && enableImageZoomActions">
    <div class="loader-container" *ngIf="isLoading && mediaType !== 'video' && mediaType !== 'audio'">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading document...</p>
    </div>

    <iframe
      *ngIf="isExternalPage"
      class="external-doc-frame"
      [src]="externalViewerUrl"
      (load)="onExternalPageLoaded()"
      (error)="onExternalPageLoadFailed()"
      referrerpolicy="no-referrer"
      title="External document viewer"
    ></iframe>

    <app-secure-media-player
      *ngIf="mediaType === 'video' || mediaType === 'audio'"
      [mediaUrl]="mediaUrl"
      [mediaType]="mediaPlayerType"
      [startTime]="startTime"
      [endTime]="endTime"
      (loaded)="onMediaLoaded()"
      (failed)="onMediaLoadFailed()"
    ></app-secure-media-player>

    <img
      *ngIf="mediaType === 'image'"
      class="secure-media secure-image"
      [src]="mediaUrl"
      [alt]="title"
      [style.transform]="'scale(' + imageZoomScale + ')'"
      draggable="false"
      (load)="onMediaLoaded()"
      (error)="onMediaLoadFailed()"
    />

    <ngx-extended-pdf-viewer
      *ngIf="mediaType === 'pdf'"
      #pdfViewer
      [src]="pdfViewerUrl"
      [page]="currentPage"
      useBrowserLocale="true"
      [showToolbar]="true"
      [showZoomButtons]="true"
      [showZoomDropdown]="false"
      [showFindButton]="true"
      [textLayer]="true"
      [showSidebarButton]="true"
      [showPagingButtons]="true"
      [showFirstAndLastPageButtons]="true"
      [showPreviousAndNextPageButtons]="true"
      [showPageNumber]="true"
      [showPageLabel]="true"
      [showPresentationModeButton]="false"
      [showDownloadButton]="false"
      [showPrintButton]="false"
      [showOpenFileButton]="false"
      [showDrawEditor]="false"
      [showHighlightEditor]="false"
      [showTextEditor]="false"
      [showStampEditor]="false"
      [showCommentEditor]="false"
      [showSignatureEditor]="false"
      [showSecondaryToolbarButton]="false"
      [showRotateCwButton]="false"
      [showRotateCcwButton]="false"
      [showHandToolButton]="false"
      [showSpreadButton]="false"
      [showPropertiesButton]="false"
      [showBookModeButton]="false"
      [showSinglePageModeButton]="false"
      [showVerticalScrollButton]="false"
      [showHorizontalScrollButton]="false"
      [showWrappedScrollButton]="false"
      [showInfiniteScrollButton]="false"
      [showMovePageButton]="false"
      [enableDragAndDrop]="false"
      [contextMenuAllowed]="false"
      [enablePrint]="false"
      (pdfLoaded)="onPdfLoaded()"
      (pdfLoadingFailed)="onPdfLoadFailed()"
      style="display: block; width: 100%; height: 100%;"
    ></ngx-extended-pdf-viewer>
  </div>
</div>
